module.exports = __webpack_public_path__ + "static/media/selectArrowDownWhite.d96e1374.svg";